import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
export const LevelItem = (_a) => {
    var { children = null } = _a, props = __rest(_a, ["children"]);
    return (_jsx("div", Object.assign({}, props, { children: children })));
};
LevelItem.displayName = 'LevelItem';
//# sourceMappingURL=LevelItem.js.map